import { useCallback, useState } from 'react'
import { setCommonModalState } from '../../../../store/slices/commonModalSlice'
import { useDispatch, useSelector } from 'react-redux'
import { AfterActions, CommonModals, Group } from '../../../types/enums'
import { useChatForOrders } from '../../../hooks/useChatForOrders'
import { selectTopics } from '../../../../store/slices/chatSlice'
import { useRefresh } from '../../../hooks/useRefresh'
import {
  CargoItemInterface,
  SlotItemInterface,
  TransportItemInterface,
} from '../../../types/interfaces'
import { selectCurrentUser } from '../../../../store/slices/currentUserSlice'
import { minContacts } from '../../../utils/constants'
import { getApi } from '../../../../api/api'

export const useStartChat = (
  order: SlotItemInterface | CargoItemInterface | TransportItemInterface,
  group: Group,
) => {
  const dispatch = useDispatch()
  const setPaymentModalState = useCallback(
    (state: boolean) => dispatch(setCommonModalState({ modal: CommonModals.PAYMENT, state })),
    [dispatch],
  )
  const setLoginModalState = useCallback(
    (state: boolean) => dispatch(setCommonModalState({ modal: CommonModals.LOGIN, state })),
    [dispatch],
  )
  const currentUser = useSelector(selectCurrentUser)
  const topics = useSelector(selectTopics)
  const { refresh } = useRefresh()
  const [api] = useState(getApi())

  const { openChatWindow } = useChatForOrders()

  const addContact = useCallback(
    async (el: SlotItemInterface) => {
      try {
        if (currentUser && currentUser.id && el.id && el.userId !== currentUser.id) {
          await api.addContact({ el_id: el.id }, group)
        }
      } catch (error) {}
    },
    [api, currentUser, group],
  )

  const startChat = useCallback(async () => {
    try {
      if (order.id) {
        const field =
          group === Group.CARGO ? 'cargoId' : group === Group.TRANSPORT ? 'transportId' : 'slotId'
        const weHaveIt = topics.find(
          (el) =>
            (el.userId === currentUser?.id || el.participantId === currentUser?.id) &&
            el[field] === order.id,
        )
        if (!weHaveIt) {
          if (!currentUser) {
            setLoginModalState(true)
            localStorage.setItem(
              'afterAction',
              JSON.stringify({
                action: AfterActions.START_CHAT,
                order: order,
              }),
            )
            return
          }
          if (
            currentUser &&
            currentUser.contacts &&
            currentUser.contacts < minContacts &&
            !weHaveIt
          ) {
            setPaymentModalState(true)
            return
          }
        }
        if (currentUser?.id) {
          await addContact(order)
          await openChatWindow(order, group, currentUser?.id)
        }
        refresh()
      }
    } catch (error) {}
  }, [
    currentUser,
    setLoginModalState,
    setPaymentModalState,
    openChatWindow,
    group,
    order,
    topics,
    refresh,
    addContact,
  ])

  return { startChat }
}
